module.exports = __webpack_public_path__ + "images/alfa-95566b.svg";